import { Subject } from 'rxjs/Subject';
import { CartItem } from './../cart/cartItem';
import { ToastType } from './../toast/toast.enum';
import { AuthService, User } from './../user/auth.service';
import { RegistryFirebaseService } from './../registry/registry-firebase.service';
import {
  Component,
  EventEmitter,
  Input,
  Output,
  OnInit,
  OnDestroy
} from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { RegistryService } from '../registry/registry.service';
import { GiftSelection } from '../gift/giftSelection';
import { Gift } from '../gift/gift';
import { CartService } from '../cart/cart.service';
import { ConfigurationService } from '../shared/configuration.service';
import { UserService } from '../user/user.service';
import { Cart } from '../cart/cart';
import { Registry } from '../registry/registry';
import 'rxjs/add/operator/takeUntil';
import { Http } from '@angular/http';
import { environment } from '../../environments/environment';
import { AnalyticsService } from '../analytics/analytics.service';
import { debounceTime } from 'rxjs/operators';
import { ToCurrencyStringPipe } from '../pipes/currencyToString.pipe';
import { PayEngineService } from '../services/payengine.service';

@Component({
  selector: 'app-gift-description',
  templateUrl: './gift-description.component.html',
  styleUrls: ['./gift-description.component.scss']
  // providers: [RegistryFirebaseService]
})
export class GiftDescriptionComponent implements OnInit, OnDestroy {
  @Input() gifts: Gift[];
  @Input() gift: Gift;
  giftSelection: GiftSelection;
  private sub: any;
  @Input() user: User;
  loaded = false;
  private giftName: string;
  private addToCartButtonText: string;
  private setToFade: boolean;
  private remaining = 0;
  private cart: Cart;
  cartSize: number;
  alreadyContainsGift: boolean;
  switchCurrency = false;
  isLoggedIn: boolean;
  baseUrl: string;
  totalConvertedCurrency: number;
  symbol: string;
  @Input() registry: Registry;
  currency: string;
  convertedPrice: number = 0;
  originalPrice: number;
  selectedPortions: number = 0;
  checkoutText: string;
  divisibleBy5AndMoreThan100 = false;
  divisibleBy25andMoreThan500 = false;
  convertToCurrency: string = "";
  private ngUnsubscribe: Subject<void> = new Subject();
  workWageSlider: object = {
    min: 1,
    max: 100,
    start: 20,
    thumbShow: true,
    barColor: '',
    dotColor: '',
    thumbColor: '',
    filledBarColor: '',
    barWidth: ''
    //  selectCallBack: this.selectCallBack.bind(this)
  };
  pricePerPortion: number;
  portionsRemaining: number;
  portionsRemainingArray: number[];
  fetchingPrice: boolean;
  convertedCurrencyRate: any;
  showTranslation: boolean;
  minAmountError: string | null = null;
  maxAmountError: string | null = null;
  isAmountValid = true;


  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private registryService: RegistryService,
    private cartService: CartService,
    private userService: UserService,
    private authService: AuthService,
    private _configuration: ConfigurationService,
    private _registryFirebaseService: RegistryFirebaseService,
    private _analyticsService: AnalyticsService,
    private _http: Http,
    private payEngineService: PayEngineService
  ) {
    this.route.params.subscribe(val => this.init());

    if (localStorage.getItem('showTranslation')) {
      this.showTranslation = true;
    } else {
      this.showTranslation = false;
    }
    this.registry = this.route.snapshot.data.registry;



  }

  portionUpdated(e) {
    this.giftSelection.price = this.pricePerPortion * this.selectedPortions;
    this.updateGiftedPrice(this.giftSelection.price);
  }

  openLink() {
    if (!this.gift.website) {
      return;
    }
    if (this.gift.website.startsWith('http://') || this.gift.website.startsWith('https://')) {
      this._analyticsService.trackEvent('Visit Gift Url', { visit_url: this.gift.website })
      window.open(this.gift.website, '_blank').focus();

    } else {
      this._analyticsService.trackEvent('Visit Gift Url', { visit_url: 'https://' + this.gift.website })
      window.open('https://' + this.gift.website, '_blank').focus();
    }
  }

  changeLang() {
    this.showTranslation = !this.showTranslation;
    if (this.showTranslation) {

      localStorage.setItem('showTranslation', 'true')
    } else {
      if (localStorage.getItem('showTranslation'))

        localStorage.removeItem('showTranslation')
    }
  }
  selectCallBack() { }
  init() {
    this.registry = this.route.snapshot.data.registry;
    this.isLoggedIn = this.route.snapshot.data.isLoggedIn;
    this.gifts = this.route.snapshot.data.gifts;

    this.symbol = this.registry.symbol;
    this.currency = this.registry.currency;
    if (this.registry && (location.search.includes('preview'))) {
      // this.router.navigate(["coming-soon"]);  
      this.isLoggedIn = false;
      this.registryService.setPreview(true);

    }
    this.registryService.nextGiftEmitted$.subscribe((gift: Gift) => {
      this.closeCurrencyConvert();
      // this.gift = gift;
      // this.applyCartLogic();

    });



    this.addToCartButtonText = 'Add to cart';

    if (this.giftSelection) {

      this.giftSelection = new GiftSelection();
      this.giftSelection.gift = new Gift();
      this.gift = new Gift();
    }

    //

    this.authService.user.subscribe(user => {
      this.user = user;
    });

    //    this._registryFirebaseService.currentRegistry.takeUntil(this.ngUnsubscribe).subscribe(registry => {
    //

    this.route.queryParams.takeUntil(this.ngUnsubscribe).subscribe(params => {
      if (params['from'] && params['from'] === 'bag') {
        this.checkoutText = 'Update in bag';
      }
    });

    if (this.gifts && this.gifts.length > 0) {
      this.sub = this.route.params.subscribe(params => {
        this.giftName = params['gifttitle'];

        if (!this.giftName) {
          return;
        }
        const hasGift =
          this.gifts.filter(
            x => x.friendlyUrl.toLowerCase() === this.giftName.toLowerCase()
          )[0] != null;
        if (!hasGift) {
          //

          this.router.navigate(['/404'], { skipLocationChange: true });
        }


        this.giftSelection = this.registryService.getGiftSelection(
          this.giftName,
          this.gifts,
          this.registry
        );
      });
      if (
        this.giftSelection.gift != null ||
        this.giftSelection.gift !== undefined
      ) {

        if (this.gift) {
          this.gift.websiteLinkText = "";
        }
        this.gift = this.gifts.filter(
          x => x.id === this.giftSelection.gift.id
        )[0];
        if (this.gift) {
          this.remaining = this.gift.remaining;
          this.registryService.setWebsiteUrl(this.gift);
          if (this.gift.portions) {
            this.pricePerPortion = this.registryService.getPortionsPricePerPortion(this.gift)
            this.portionsRemaining = this.registryService.getPortionsRemaining(this.gift)
            if (this.portionsRemaining >= 0) {


              this.portionsRemainingArray = new Array<number>();
              ;
              this.portionsRemainingArray = Array(this.portionsRemaining).fill(0).map((x, i) => i + 1);
              this.selectedPortions = 1;

              this.portionUpdated(null);
            }
          }
        }

      }

      if (this.gift && !this.gift.portions) {
        this.giftSelection.price = this.getDefaultGiveAmount();
      }
      this.loaded = true;
      this.baseUrl = this._configuration.baseUrl;
      this.cartSize = 0;

      this.divisibleBy5AndMoreThan100 =
        this.giftSelection.gift.remaining % 5 === 0 &&
        this.giftSelection.gift.remaining >= 101 &&
        this.giftSelection.gift.remaining <= 500;
      this.divisibleBy25andMoreThan500 =
        this.giftSelection.gift.remaining % 25 === 0 &&
        this.giftSelection.gift.remaining >= 501;

      // if (this.isLoggedIn) {
      //   this.cartService.clearCart();
      // }
      this.applyCartLogic();
    }
  }

  // getSliderValue(slider: any) {
  //   if (slider) {
  //     const min: number = slider.min;
  //     const max: number = slider.max;
  //     const value: number = slider.value;
  //     const val: number = (value - min) / (max - min);
  //     return val;
  //   }
  //   return 0;
  // }

  // onSlid(slider: any) {

  //   const min: number = slider.min;
  //   const max: number = slider.max;
  //   const value: number = slider.value;
  //   const val: number = (value - min) / (max - min);

  //   slider.style.backgroundImage =
  //     '-webkit-gradient(linear, left top, right top, '
  //     + 'color-stop(' + val + ', #000080), '
  //     + 'color-stop(' + val + ', #C5C5C5)';

  // }
  changeCurrency(event) {

    if (event) {
      this.getPriceInCurrencies(event);
    }

  }
  changeCurrencyReverse(event) {

    if (event && this.convertToCurrency) {

      this.giftSelection.price = event * (1 / this.convertedCurrencyRate);

      this.giftSelection.price = Math.round(this.giftSelection.price);
      this.fetchingPrice = false;
    }
    this.updateGiftedPrice(this.giftSelection.price);
    this.checkAmounts();
  }



  // Store timeout ID for debouncing
  private checkAmountsTimeout: any = null;

  updateGiftedPrice(event) {
    if (this.convertToCurrency) {
      this.totalConvertedCurrency = event * this.convertedCurrencyRate;
      this.totalConvertedCurrency = Math.round(this.totalConvertedCurrency);
      this.fetchingPrice = false;
    }

    // Update button state immediately
    const isBelowMin = this.registryService.isAmountBelowMinimum(this.giftSelection.price, this.registry.currency);
    const isAboveMax = this.registryService.isAmountAboveMaximum(this.giftSelection.price, this.registry.currency);
    const isAboveRemaining = this.gift && this.giftSelection.price > this.gift.remaining;
    this.isAmountValid = !isBelowMin && !isAboveMax && !isAboveRemaining;

    // Debounce the error message display
    if (this.checkAmountsTimeout) {
      clearTimeout(this.checkAmountsTimeout);
    }

    this.checkAmountsTimeout = setTimeout(() => {
      this.checkAmounts();
    }, 800);
  }
  openCurrency() {
    this.switchCurrency = true;
    let currencies = ['USD', 'EUR', 'CAD']
    this.convertToCurrency = currencies.filter(x => x != this.registry.currency)[0];
    this.getPriceInCurrencies(this.convertToCurrency);
    this.checkAmounts();
  }
  closeCurrencyConvert() {
    this.switchCurrency = false;
    this.totalConvertedCurrency = null;
    this.convertToCurrency = '';
  }

  getPriceInCurrencies(currency) {

    this.convertedCurrencyRate = null;
    if (this.registry.currency == currency) {
      this.totalConvertedCurrency = this.giftSelection.price;
      this.convertedCurrencyRate = 1;
      return;
    }

    this.fetchingPrice = true
    this._http.get(environment.firebase.clouldFunctionHost + '/getForexPrices?currency=' + this.registry.currency)
      .subscribe((response: any) => {

        if (response != null && response._body) {
          const jsonResponse: any = JSON.parse(response._body);

          this.convertedCurrencyRate = jsonResponse.exchange_rates[currency]
          this.totalConvertedCurrency = this.giftSelection.price * this.convertedCurrencyRate
          this.totalConvertedCurrency = Math.round(this.totalConvertedCurrency);
          this.fetchingPrice = false;
        }
      });
  }

  ngOnInit() {
    this.init();
    this.registryService.showTranslationEmitted$.subscribe(x => {

      this.showTranslation = x;

    });

    // Initial amount validation
    this.checkAmounts();
  }

  applyCartLogic() {
    this.cart = this.cartService.getCart();

    if (this.cart) {
      if (this.cart.cartItems) {
        this.cartSize = this.cart.cartItems.length;
      } else {
        this.cartSize = 0;
      }
      this.alreadyContainsGift = !(
        this.cart.cartItems.findIndex(x => x.gift.id === this.gift.id) === -1
      );
      if (this.alreadyContainsGift) {
        this.giftSelection.price = this.cart.cartItems.find(
          x => x.gift.id === this.gift.id
        ).price;
        return this.giftSelection.price;
      }
    }
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();

    // Clear any pending timeouts
    if (this.checkAmountsTimeout) {
      clearTimeout(this.checkAmountsTimeout);
    }
  }

  getDefaultGiveAmount(): number {
    let remaining: number;

    if (!this.registry.showRecommendedAmount) {
      this.giftSelection.price = null;
      return null;
    }


    if (this.registry.defaultGiftPrice) {
      // if remaining amount is less than the set default amount then set the remaining as that.
      if (this.gift.remaining <= this.registry.defaultGiftPrice) {
        remaining = this.gift.remaining;
      } else {
        remaining = this.registry.defaultGiftPrice;
      }
      return remaining as number;
    }

    if (this.gift.remaining <= 100) {
      remaining = this.gift.remaining / 2;
    } else {
      remaining = 100;
    }
    remaining = parseInt(remaining.toString(), 0);

    return remaining as number;
  }

  viewBag() {
    if (this.isLoggedIn) {
      this.router.navigate(['/registry/bag']);
    } else {
      this.router.navigate([this.registry.registryName + '/bag']);
    }
  }

  addToCart() {
    this.cartService.addToCart(
      this.giftSelection.gift,
      this.giftSelection.price
    );
    this.alreadyContainsGift = true;
    localStorage.setItem('toast_' + ToastType.addedToCart, 'true');
    this.cart = this.cartService.getCart();
    this.cartSize = this.cart.cartItems.length;
    this.registryService.emitToastType(ToastType.addedToCart);
    this.cartService.emitCartUpdated(this.cartService.getCart());
  }

  buyFullGiftAndNavigateToWish() {
    this.giftSelection.price = this.gift.remaining;
    this.navigateToWish();
  }

  navigateToWish() {
    this.registryService.setGiftSelection(this.giftSelection);

    // Start PayEngine initialization early for better performance
    this.initializePayEngineEarly();

    let returnAddress = "/" + this.registry.registryName
    if (location.href.toLowerCase().includes('/registry/')) {
      returnAddress = "/" + this.registry.registryName + "/registry"
    }
    if (this.isLoggedIn) {
      this.router.navigate([
        '/registry/' + this.giftSelection.gift.friendlyUrl.toLowerCase(),
        'wish'
      ]);
    } else if (location.pathname.includes('your-registry')) {
      this.router.navigate([
        'your-registry',
        this.giftSelection.gift.friendlyUrl.toLowerCase(),
        'wish'
      ]);
    }

    else {
      this.router.navigate([
        returnAddress,
        this.giftSelection.gift.friendlyUrl.toLowerCase(),
        'wish'
      ]);
    }

    // this.router.navigate(['/contribute']);
  }
  removeFromCart() {
    const removingCartItem: CartItem = new CartItem();
    removingCartItem.gift = this.gift;
    this.cartService.RemoveCartItem(removingCartItem);
    this.cart = this.cartService.getCart();
    this.cartSize = this.cart.cartItems.length;
    this.alreadyContainsGift = false;
  }

  focusToBottom() {
    window.scrollTo(0, document.body.scrollHeight);
  }

  addToCartAndGoToCart() {
    this.cartService.addToCart(
      this.giftSelection.gift,
      this.giftSelection.price
    );
    if (this.isLoggedIn) {
      this.router.navigate(['/registry/bag']);
    } else {
      this.router.navigate([this.registry.registryName + '/bag']);
    }
  }

  checkAmounts() {
    // Immediate validation for button state
    const isBelowMin = this.registryService.isAmountBelowMinimum(this.giftSelection.price, this.registry.currency);
    const isAboveMax = this.registryService.isAmountAboveMaximum(this.giftSelection.price, this.registry.currency);
    const isAboveRemaining = this.gift && this.giftSelection.price > this.gift.remaining;

    // Disable button immediately for any validation error
    this.isAmountValid = !isBelowMin && !isAboveMax && !isAboveRemaining;

    // Clear both errors initially
    this.maxAmountError = null;
    this.minAmountError = null;

    if (this.giftSelection.price !== null && this.giftSelection.price !== 0) {
      if (isBelowMin) {
        // Show min amount error if below minimum
        this.minAmountError = this.registryService.getMinAmountErrorMessage(this.registry);
      } else {
        // Determine which max error to show based on which limit is lower
        const maxGiftLimit = this.registryService.getMaxAmountForCurrency(this.registry.currency);
        const remainingAmount = this.gift ? this.gift.remaining : Infinity;

        if (this.giftSelection.price > Math.min(maxGiftLimit, remainingAmount)) {
          if (remainingAmount <= maxGiftLimit) {
            // Show remaining amount error if it's the lower limit
            const roundedRemaining = Math.floor(remainingAmount);
            const formattedRemaining = roundedRemaining.toLocaleString(undefined, { maximumFractionDigits: 0 });
            this.maxAmountError = this.registry.symbol + formattedRemaining + ' is the most you can give towards this gift';
          } else {
            // Show max gift limit error if it's the lower limit
            this.maxAmountError = this.registryService.getMaxAmountErrorMessage(this.registry);
          }
        }
      }
    }
  }

  /**
   * Initialize PayEngine early in the background for better performance
   */
  private initializePayEngineEarly(): void {
    // Check if PayEngine is already loaded or loading
    if (this.payEngineService.isReady() || this.payEngineService.isLoading()) {
      return;
    }

    // Start PayEngine initialization in the background
    this.payEngineService.initializePayEngine().catch(error => {
      console.warn('Early PayEngine initialization failed:', error);
      // Don't throw error here since this is a performance optimization
      // The actual payment component will handle initialization if this fails
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/gift-description/gift-description.component.ts